import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ILocationInitialState} from "../types";
import {IEntityWithIDTranslations} from "../../../../../../../types";
import {GetDeleteLocation,GetLocation} from "../store/thunk";

const initialState: ILocationInitialState = {
    location: [],
    selectedLocationIDs: [],
    isLoadingLocation:true,
    locationRestore:[],
    isLocationRestore:false,
    filteredLocation:[]
}


const locationDetailsSlice = createSlice({
    name: "locationDetails",
    initialState,
    reducers: {
        setLocation: (state, action: PayloadAction<{data:IEntityWithIDTranslations[],defaultLanguage:string}>) => {
            const {data,defaultLanguage} = action.payload;
            state.location= data
            state.filteredLocation = data.flatMap(
                (data) => {
                    return data.translations
                        .filter((elem) => elem.slug === defaultLanguage)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name || "Unknown Name",

                        }));
                }
            );
        },
        deletedLocation: (state, action: PayloadAction<number>) => {
            state.location= state.location.filter((elem) => elem.id !== action.payload);
        },
        updateLocation: (state, action: PayloadAction<IEntityWithIDTranslations>) => {
            const updateData = action.payload;

            state.location = state.location.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setLocationRestore:(state, action) => {
            state.locationRestore = action.payload;
        },
        setIsLocationRestore:(state)=>{

            state.isLocationRestore =!state.isLocationRestore;
        },
        deletedRestoreLocation:(state,action)=>{
            state.locationRestore = state.locationRestore.filter(
                (elem) => elem.id !== action.payload
            );
        },
        setSelectedLocationIDs: (state, action) => {
            state.selectedLocationIDs=action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetLocation.pending, (state) => {
                state.isLoadingLocation = true;
            })
            .addCase(GetLocation.fulfilled, (state) => {
                state.isLoadingLocation = false;
            })
            .addCase(GetLocation.rejected, (state) => {
                state.isLoadingLocation = false;
            })
            .addCase(GetDeleteLocation.pending, (state) => {
                state.isLoadingLocation = true;
            })
            .addCase(GetDeleteLocation.fulfilled, (state) => {
                state.isLoadingLocation = false;
            })
            .addCase(GetDeleteLocation.rejected, (state) => {
                state.isLoadingLocation = false;
            });
    },
})

export const {
    setSelectedLocationIDs,
    setIsLocationRestore,
    deletedRestoreLocation,
    deletedLocation,
    setLocationRestore,
    updateLocation,
    setLocation
}=locationDetailsSlice.actions;


export default locationDetailsSlice